export default __webpack_public_path__ + "static/media/houndstooth.ef56e0b08798536cefb826a1c7e5b8e1.svg";